import React, { useEffect, useState } from 'react';
import { settingsApi, carriersApi, discountsApi } from '../services/api';

function CarriersSection() {
  const [carriers, setCarriers] = useState([]);
  const [form, setForm] = useState({ name: '', code: '', price: '', cod_extra: '', requires_branch: false });
  const [showForm, setShowForm] = useState(false);
  const [adding, setAdding] = useState(false);

  useEffect(() => { carriersApi.list().then(setCarriers).catch(() => {}); }, []);

  async function add() {
    if (!form.name || !form.code) return;
    setAdding(true);
    try {
      await carriersApi.create(form);
      setCarriers(await carriersApi.list());
      setForm({ name: '', code: '', price: '', cod_extra: '', requires_branch: false });
      setShowForm(false);
    } finally { setAdding(false); }
  }

  async function toggle(id, is_active) {
    await carriersApi.update(id, { is_active: is_active ? 0 : 1 });
    setCarriers(cs => cs.map(c => c.id === id ? { ...c, is_active: is_active ? 0 : 1 } : c));
  }

  async function remove(id) {
    if (!window.confirm('Smazat dopravce?')) return;
    await carriersApi.delete(id);
    setCarriers(cs => cs.filter(c => c.id !== id));
  }

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div className="card-title">🚚 Dopravci</div>
        <button className="btn btn-primary" onClick={() => setShowForm(f => !f)}>+ Přidat dopravce</button>
      </div>

      {showForm && (
        <div style={{ background: '#f8f9fa', borderRadius: 8, padding: 16, marginBottom: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12 }}>
          {[['name','Název *'],['code','Kód * (zasilkovna, ppl…)'],['price','Cena (Kč)'],['cod_extra','Příplatek dobírka (Kč)']].map(([k,l]) => (
            <div className="form-group" key={k}>
              <label className="form-label">{l}</label>
              <input className="form-control" value={form[k]} onChange={e => setForm(f => ({...f,[k]:e.target.value}))} />
            </div>
          ))}
          <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 22 }}>
            <input type="checkbox" id="rb" checked={form.requires_branch} onChange={e => setForm(f => ({...f,requires_branch:e.target.checked}))} />
            <label htmlFor="rb" style={{ fontSize: 13 }}>Vyžaduje výběr pobočky</label>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', paddingTop: 22 }}>
            <button className="btn btn-primary" onClick={add} disabled={adding}>{adding ? '...' : 'Uložit'}</button>
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Zrušit</button>
          </div>
        </div>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
        <thead>
          <tr style={{ borderBottom: '2px solid #eee' }}>
            {['Název','Kód','Cena','Dobírka','Pobočka','Aktivní',''].map(h => (
              <th key={h} style={{ textAlign: 'left', padding: '6px 10px', fontWeight: 600, color: '#555', fontSize: 12 }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {carriers.map(c => (
            <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
              <td style={{ padding: '8px 10px', fontWeight: 500 }}>{c.name}</td>
              <td style={{ padding: '8px 10px', color: '#888' }}>{c.code}</td>
              <td style={{ padding: '8px 10px' }}>{c.price} Kč</td>
              <td style={{ padding: '8px 10px' }}>{c.cod_extra > 0 ? `+${c.cod_extra} Kč` : '—'}</td>
              <td style={{ padding: '8px 10px' }}>{c.requires_branch ? '✓' : '—'}</td>
              <td style={{ padding: '8px 10px' }}>
                <span onClick={() => toggle(c.id, c.is_active)} style={{ cursor: 'pointer', fontSize: 20 }}>{c.is_active ? '🟢' : '⚫'}</span>
              </td>
              <td style={{ padding: '8px 10px' }}>
                <button onClick={() => remove(c.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 16 }}>🗑</button>
              </td>
            </tr>
          ))}
          {carriers.length === 0 && <tr><td colSpan={7} style={{ padding: '16px 10px', color: '#aaa', fontSize: 13 }}>Žádní dopravci</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

function DiscountsSection() {
  const [codes, setCodes] = useState([]);
  const [form, setForm] = useState({ code: '', type: 'percent', value: '', min_order: '', max_uses: '', expires_at: '' });
  const [showForm, setShowForm] = useState(false);
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { discountsApi.list().then(setCodes).catch(() => {}); }, []);

  async function add() {
    if (!form.code || !form.value) { setError('Kód a hodnota jsou povinné'); return; }
    setAdding(true); setError('');
    try {
      await discountsApi.create(form);
      setCodes(await discountsApi.list());
      setForm({ code: '', type: 'percent', value: '', min_order: '', max_uses: '', expires_at: '' });
      setShowForm(false);
    } catch (e) { setError(typeof e === 'string' ? e : 'Kód již existuje'); }
    finally { setAdding(false); }
  }

  async function toggle(id, is_active) {
    await discountsApi.update(id, { is_active: is_active ? 0 : 1 });
    setCodes(cs => cs.map(c => c.id === id ? { ...c, is_active: is_active ? 0 : 1 } : c));
  }

  async function remove(id) {
    if (!window.confirm('Smazat slevový kód?')) return;
    await discountsApi.delete(id);
    setCodes(cs => cs.filter(c => c.id !== id));
  }

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div className="card-title">🏷️ Slevové kódy</div>
        <button className="btn btn-primary" onClick={() => setShowForm(f => !f)}>+ Přidat kód</button>
      </div>

      {showForm && (
        <div style={{ background: '#f8f9fa', borderRadius: 8, padding: 16, marginBottom: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12, marginBottom: 12 }}>
            <div className="form-group">
              <label className="form-label">Kód *</label>
              <input className="form-control" value={form.code} onChange={e => setForm(f => ({...f,code:e.target.value.toUpperCase()}))} placeholder="SLEVA10" />
            </div>
            <div className="form-group">
              <label className="form-label">Typ</label>
              <select className="form-control" value={form.type} onChange={e => setForm(f => ({...f,type:e.target.value}))}>
                <option value="percent">Procenta (%)</option>
                <option value="amount">Pevná částka (Kč)</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Hodnota * {form.type === 'percent' ? '(%)' : '(Kč)'}</label>
              <input className="form-control" type="number" value={form.value} onChange={e => setForm(f => ({...f,value:e.target.value}))} />
            </div>
            <div className="form-group">
              <label className="form-label">Min. objednávka (Kč)</label>
              <input className="form-control" type="number" value={form.min_order} onChange={e => setForm(f => ({...f,min_order:e.target.value}))} placeholder="0 = bez limitu" />
            </div>
            <div className="form-group">
              <label className="form-label">Max. použití</label>
              <input className="form-control" type="number" value={form.max_uses} onChange={e => setForm(f => ({...f,max_uses:e.target.value}))} placeholder="0 = neomezeno" />
            </div>
            <div className="form-group">
              <label className="form-label">Platnost do</label>
              <input className="form-control" type="date" value={form.expires_at} onChange={e => setForm(f => ({...f,expires_at:e.target.value}))} />
            </div>
          </div>
          {error && <div style={{ color: '#721c24', fontSize: 13, marginBottom: 8 }}>{error}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary" onClick={add} disabled={adding}>{adding ? '...' : 'Uložit'}</button>
            <button className="btn btn-secondary" onClick={() => { setShowForm(false); setError(''); }}>Zrušit</button>
          </div>
        </div>
      )}

      {codes.length === 0 ? (
        <div style={{ color: '#aaa', fontSize: 14, padding: '12px 0' }}>Žádné slevové kódy</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #eee' }}>
              {['Kód','Typ','Hodnota','Min. obj.','Použití','Platnost','Aktivní',''].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '6px 10px', fontWeight: 600, color: '#555', fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {codes.map(c => (
              <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '8px 10px', fontWeight: 600 }}>{c.code}</td>
                <td style={{ padding: '8px 10px', color: '#888' }}>{c.type === 'percent' ? '%' : 'Kč'}</td>
                <td style={{ padding: '8px 10px' }}>{c.value}{c.type === 'percent' ? ' %' : ' Kč'}</td>
                <td style={{ padding: '8px 10px' }}>{c.min_order > 0 ? `${c.min_order} Kč` : '—'}</td>
                <td style={{ padding: '8px 10px' }}>{c.uses_count}{c.max_uses > 0 ? ` / ${c.max_uses}` : ''}</td>
                <td style={{ padding: '8px 10px' }}>{c.expires_at || '—'}</td>
                <td style={{ padding: '8px 10px' }}>
                  <span onClick={() => toggle(c.id, c.is_active)} style={{ cursor: 'pointer', fontSize: 20 }}>{c.is_active ? '🟢' : '⚫'}</span>
                </td>
                <td style={{ padding: '8px 10px' }}>
                  <button onClick={() => remove(c.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 16 }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function EshopSettings() {
  const [settings, setSettings] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { settingsApi.get().then(setSettings); }, []);

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await settingsApi.update(settings);
      setMsg('Uloženo'); setTimeout(() => setMsg(''), 2500);
    } finally { setSaving(false); }
  }

  const fields = [
    ['shop_title', 'Název eshopu'],
    ['shop_tagline', 'Tagline'],
    ['shop_facebook_url', 'Odkaz na Facebook skupinu'],
    ['shop_hero_eyebrow', 'Hero — drobný text nad nadpisem'],
    ['shop_hero_heading', 'Hero — hlavní nadpis'],
    ['shop_hero_subtext', 'Hero — popis'],
    ['shop_pickup_address', 'Adresa osobního odběru'],
    ['shipping_cost', 'Základní cena dopravy (Kč)'],
    ['free_shipping_from', 'Doprava zdarma od (Kč)'],
    ['vat_registered', 'Plátce DPH v eshopu (0 / 1)'],
    ['vat_rate', 'Sazba DPH (%)'],
  ];

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div className="card-title">⚙️ Nastavení eshopu</div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {msg && <span style={{ color: '#1a7a3e', fontSize: 13 }}>✓ {msg}</span>}
          <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Ukládám...' : 'Uložit'}</button>
        </div>
      </div>
      <form onSubmit={save}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
          {fields.map(([key, label]) => (
            <div className="form-group" key={key}>
              <label className="form-label">{label}</label>
              <input className="form-control" value={settings[key] || ''} onChange={e => setSettings(s => ({...s,[key]:e.target.value}))} />
            </div>
          ))}
        </div>
      </form>
    </div>
  );
}

export default function Eshop() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">🛒 Eshop</h1>
        <a href="/shop" target="_blank" rel="noreferrer" className="btn btn-secondary">Otevřít eshop →</a>
      </div>
      <EshopSettings />
      <CarriersSection />
      <DiscountsSection />
    </div>
  );
}
